import { render, staticRenderFns } from "./autoRenewalTender.vue?vue&type=template&id=36c3ccc4"
import script from "./autoRenewalTender.vue?vue&type=script&lang=js"
export * from "./autoRenewalTender.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports